document.addEventListener("DOMContentLoaded", function () {
      // Wait for fonts to load before starting animation
      if (document.fonts) {
        document.fonts.ready.then(function() {
          startTypewriter();
        });
      } else {
        // Fallback for older browsers
        setTimeout(startTypewriter, 500);
      }

      function startTypewriter() {
        const texts = [
          "\"Super customer service. Made a personal wish possible. Highly recommended\" ⭐⭐⭐⭐⭐",
          "\"Excellent fast service, and very friendly customer service. Really pleased with the product also - thank you!\" ⭐⭐⭐⭐⭐",
          "\"I received this as a gift, the design & quality is amazing, really nice product and idea\" ⭐⭐⭐⭐⭐",
          "\"Great service & product, well impressed\" ⭐⭐⭐⭐⭐"
        ];

        const highlightColor = 'linear-gradient(120deg, #a8edea 0%, #fed6e3 100%)';
        const targetEl = document.getElementById("type-js");
        let currentTextIndex = 0;
        let letterIndex = 0;
        let typingSpeed = 80;

        function typeText() {
          if (!targetEl) return;

          if (letterIndex === 0) {
            setTimeout(() => {
              targetEl.innerHTML = '';
              requestAnimationFrame(typeNextChar);
            }, 400);
          } else {
            requestAnimationFrame(typeNextChar);
          }
        }

        function typeNextChar() {
          if (letterIndex < texts[currentTextIndex].length) {
            targetEl.innerHTML += texts[currentTextIndex].charAt(letterIndex);
            letterIndex++;
            
            const randomDelay = typingSpeed + (Math.random() * 40 - 20);
            setTimeout(typeText, Math.max(50, randomDelay));
          } else {
            currentTextIndex = (currentTextIndex + 1) % texts.length;
            letterIndex = 0;
            setTimeout(typeText, 2000);
          }
        }

        typeText();
      }
    });